import axios from "axios";

import {
  decrementActiveRequests,
  hideLoader,
  showLoader,
  incrementActiveRequests,
} from "../Store/Reducers/LoaderSlice";
import Store from "../Store/Store";

// Add axios interceptors for loader handling
export const setupInterceptors = () => {
  axios.interceptors.request.use(
    config => {
      Store.dispatch(incrementActiveRequests());
      Store.dispatch(showLoader());
      return config;
    },
    error => {
      Store.dispatch(decrementActiveRequests());
      Store.dispatch(hideLoader());
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    response => {
      Store.dispatch(decrementActiveRequests());
      Store.dispatch(hideLoader());
      return response;
    },
    error => {
      Store.dispatch(decrementActiveRequests());
      Store.dispatch(hideLoader());
      return Promise.reject(error);
    }
  );
};
